module.exports = __webpack_public_path__ + "static/media/footer_popup_call_icon.57257c84.svg";